import { state } from './state'
import { actions } from './actions'

import { defineStore } from "pinia";

export const useLoadingStore = defineStore("loader", {
  state: state,
  actions: actions,
});


